import styled from 'styled-components'
import Input from './Input'
import {
  ChangeEvent,
  CourseContent,
  youtubeUrl,
} from '@bm-js/atlascloud-shared'

const StyledCourseEditableYoutube = styled.div`
  .iframe-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    margin-bottom: 2rem;
    border-radius: 4px;
    overflow: hidden;
  }
  .iframe-container iframe {
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

type Props = {
  content: CourseContent
  setContentData: (data: CourseContent['data']) => void
}

const CourseEditableYoutube = ({ content, setContentData }: Props) => {
  const setVideo = (e: ChangeEvent) => {
    const val = e.target.value
    const id = youtubeUrl(val)
    const embedLink = `https://www.youtube.com/embed/${id}`
    setContentData({
      ...content.data,
      fullLink: val,
      id: id || '',
      embedLink: id ? embedLink : '',
    })
  }

  return (
    <StyledCourseEditableYoutube>
      <Input
        type='text'
        placeholder='Klistra in YouTubelänk'
        value={content.data.fullLink}
        onChange={setVideo}
      />

      {content.data.fullLink && (
        <>
          <p className='m0 label'>Förhandsvisning</p>
          {content.data.embedLink ? (
            <div className='iframe-container'>
              <iframe
                width='1920'
                height='1080'
                src={content.data.embedLink}
                title='YouTube video player'
                allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              />
            </div>
          ) : (
            <p className='m-0 font-bold text-red-600'>Felaktig länk</p>
          )}
        </>
      )}
    </StyledCourseEditableYoutube>
  )
}

export default CourseEditableYoutube
